/* ==========================================================================
   MASHWI — L'écosystème : indicateurs du défilement horizontal (mobile)
   Vanilla, aucune dépendance. Respecte prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  function initEcosystem(section) {
    if (!section || section.dataset.mwEcosystemInit === 'true') return;

    var track = section.querySelector('.mw-ecosystem__track');
    var dots = Array.prototype.slice.call(section.querySelectorAll('.mw-ecosystem__dot'));
    if (!track || dots.length === 0) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.mw-ecosystem__card'));
    if (cards.length === 0) return;

    section.dataset.mwEcosystemInit = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            setActive(cards.indexOf(entry.target));
          });
        },
        { root: track, threshold: 0.6 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        setActive(i);
        track.scrollTo({
          left: cards[i].offsetLeft - cards[0].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.mw-section--ecosystem').forEach(initEcosystem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Éditeur de thème Shopify : réinitialiser au rechargement de la section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
